import { observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { unixEpoch } from '@/utils/date-util'
import { ContactInfo } from '@/features/jobs/info-gathering/ContactInfo'
import { BusinessInfo } from './BusinessInfo'

export type BusinessProfileVersionProps = ModelProps<BusinessProfileVersion>

/**
 * A version of a business profile.
 */
export class BusinessProfileVersion extends Model<BusinessProfileVersion> {
  id = Id.none

  @observable accessor version = 0
  @observable accessor workspaceId = Id.none
  @observable accessor ownerUserId = Id.none
  @observable accessor createdAt = unixEpoch()
  @observable accessor updatedAt = unixEpoch()
  @observable.shallow accessor businessInfo: BusinessInfo = BusinessInfo.empty
  @observable.shallow accessor contactInfo: ContactInfo = ContactInfo.empty
}

/**
 * Formats an ID string for the backing collection of business profile
 * versions.
 */
export const BusinessProfileVersionId = {
  from: (id: Id, version: number | undefined): string => {
    if (version === undefined) {
      throw new TypeError('Profile version ID cannot be undefined')
    }

    return `${Id.assert(id)}@v${version}`
  },
}
